/**
 * Menu Item Card Component
 * Shows item name (localized), description, price, diet tags, and stepper/add button.
 */

import { getCurrentLanguage } from '../../../i18n';
import { renderQtyStepper } from './qty-stepper';
import type { MenuItem } from '../types';

const TAG_LABELS: Record<string, string> = {
  veg: '🌿',
  spicy: '🌶',
  gf: '🌾',
};

const SOLD_OUT: Record<string, string> = {
  th: 'หมดแล้ว', en: 'Sold out', zh: '售罄', ru: 'Нет в наличии', ja: '売り切れ', ko: '품절',
};

export function renderMenuItemCard(item: MenuItem, qty: number): string {
  const lang = getCurrentLanguage();
  const name = (item.name as Record<string, string>)[lang] || item.name.en || (item.name as any).th || '';
  const rawDesc = item.description || item.desc;
  const desc = rawDesc ? (typeof rawDesc === 'string' ? rawDesc : (rawDesc as Record<string, string>)[lang] || (rawDesc as any).en || (rawDesc as any).th || '') : '';

  const tagBadges = item.tags.map((tag) =>
    `<span style="font-size:14px;line-height:1;">${TAG_LABELS[tag] ?? ''}</span>`
  ).join('');

  const priceStr = `฿${item.price.toLocaleString()}`;

  const rightContent = item.available
    ? renderQtyStepper(item.id, qty)
    : `<span style="
        padding:6px 10px;border-radius:6px;background:#f0f0f0;
        color:#999;font-size:12px;font-weight:600;
      ">${SOLD_OUT[lang] || SOLD_OUT.en}</span>`;

  return `
    <div class="menu-item-card" data-item-id="${item.id}" style="
      display:flex;align-items:flex-start;justify-content:space-between;gap:12px;
      padding:14px 16px;border-bottom:1px solid #f0f0f0;background:#fff;
    ">
      <div
        style="flex:1;min-width:0;cursor:pointer;"
        onclick="window.openDishDetail?.('${item.id}')"
      >
        <div style="
          font-size:14px;font-weight:600;color:#1a1a1a;
          margin-bottom:${desc ? '4px' : '6px'};line-height:1.35;
        ">${name}${tagBadges ? `<span style="margin-left:6px;">${tagBadges}</span>` : ''}</div>
        ${desc ? `<div style="
          font-size:12px;color:#666;line-height:1.4;margin-bottom:8px;
          display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;
        ">${desc}</div>` : ''}
        <div style="font-size:15px;font-weight:700;color:#00B900;">${priceStr}</div>
      </div>
      ${item.imageUrl ? `
      <div class="menu-item-media" style="flex:0 0 76px;display:flex;flex-direction:column;align-items:flex-end;gap:8px;">
        <div
          onclick="window.openDishDetail?.('${item.id}')"
          style="width:76px;height:76px;border-radius:10px;overflow:hidden;background:#f5f5f5;box-shadow:0 1px 3px rgba(0,0,0,0.06);cursor:pointer;"
        >
          <img
            src="${item.imageUrl}"
            alt="${name}"
            loading="lazy"
            onerror="this.style.display='none'"
            style="width:100%;height:100%;object-fit:cover;display:block;"
          />
        </div>
        <div style="width:100%;display:flex;justify-content:flex-end;">
          ${rightContent}
        </div>
      </div>
      ` : `
      <div style="flex:0 0 auto;display:flex;align-items:center;padding-top:2px;">
        ${rightContent}
      </div>
      `}
    </div>
  `;
}
